const prefix: string = '@ARP-';

interface IPropsData {
    type: string,
    value: string,
}

interface ILocalStorage {
    key: string;
    object: Object;
}

/* Lista de Telas */
export const displayList = [
    { 
        type: prefix+'login',
        value: '', 
        pathName: '/', 
        description: 'Dados básicos',
        message: 'Login'
    },
    { 
        type: prefix+'paginacao',
        value: '', 
        pathName: '/', 
        description: 'Dados paginação',
        message: 'Pagina'
    },
    { 
        type: prefix+'dados',
        value: '', 
        pathName: '/', 
        description: 'Dados usuário',
        message: 'Dados'
    }
]

export function writeStorage(props: ILocalStorage) {
    localStorage.setItem(prefix+props.key, JSON.stringify(props.object));
}

export function setAllItems(){
    displayList.map((item) => {
        if ( !localStorage.getItem(item.type) ){
            localStorage.setItem(item.type, JSON.stringify(''));
        }
        return item.type;   
    });
  
}

export function getAllItems(){
    for(let i=0, len=localStorage.length; i<len; i++) {
        let key = localStorage.key(i);
        if(key){
            let value = localStorage[key];
            let item = displayList.find(({type}) => type === key )
                if(item){
                  item.value = JSON.parse(value);
                }
        }
    }
}

export function setDataStorage(props: Array<IPropsData>) {
    props.forEach((element) => {
        const value: string | null = localStorage.getItem(element.type)
        if(value){
            element.value = JSON.parse(value); 
        }
    })
    return props;
}

export function readDataStorage(key: string){
     const value = displayList.find(({type}) => type === prefix+key)
     if(value && localStorage.getItem(value.type)){
        const data:string | null = localStorage.getItem(value.type); 
        if(data){
            return JSON.parse(data);
        }
     }
     return {}
}